import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

var styles = {"drawer-wrapper":"drawer-module_drawer-wrapper__x2qj-","focused":"drawer-module_focused__BuFt1","drawer":"drawer-module_drawer__OBNZy","drawer-content":"drawer-module_drawer-content__prv0I","expanded":"drawer-module_expanded__OX4Y-","toggle":"drawer-module_toggle__n2-n9"};

var Drawer = function Drawer(props) {
  var _a = useState(true),
    expanded = _a[0],
    setExpanded = _a[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "\n            " + styles["drawer-wrapper"] + " \n            " + (props.focused ? styles["focused"] : "") + "\n            " + (expanded ? styles["expanded"] : "") + "\n            " + (props.className ? props.className : "")
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: styles["toggle"],
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    size: "large"
  }, expanded ? /*#__PURE__*/React.createElement(ChevronLeft, {
    color: "primary"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    color: "primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles["drawer"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["drawer-content"]
  }, props.children)));
};

export { Drawer };
